import { useBasisTheory } from '@basis-theory/react-elements';
import { useBasisTheoryElementRefs } from './basis-theory-elements.context';

const CARD_ELEMENT_ID = 'CARD_ELEMENT_ID';

export const useBasisTheoryToken = () => {
  const { bt } = useBasisTheory();
  const { cardRef, routingNumberRef, accountNumberRef, accountHolderNameRef } = useBasisTheoryElementRefs();

  const getBasisTheoryCCToken = async () => {
    const { data, id } = await bt.tokens.create({
      type: 'card',
      data: cardRef.current
    });
    const { expiration_month: expirationMonth, expiration_year: expirationYear, number } = data;
    return {
      card: {
        expirationMonth,
        expirationYear,
        last4: number.slice(-4)
      },
      token: id
    };
  };

  const getBasisTheoryACHToken = async () => {
    return bt.tokens.create({
      type: 'token',
      privacy: {
        classification: 'bank',
        impact_level: 'high',
        restriction_policy: 'mask'
      },
      mask: {
        routing_number: '{{ data.routing_number }}',
        account_number: '{{ data.account_number | reveal_last: 4 }}'
      },
      data: {
        routing_number: routingNumberRef.current,
        account_number: accountNumberRef.current,
        account_holder_name: accountHolderNameRef.current
      }
    });
  };

  return { cardElementId: CARD_ELEMENT_ID, getBasisTheoryCCToken, getBasisTheoryACHToken };
};
